var map = {
	"./city-color.jpg": 255,
	"./city.jpg": 428,
	"./holly-color.jpg": 334,
	"./holly.jpg": 22,
	"./la.jpg": 198,
	"./p1-color.jpg": 671,
	"./p1.jpg": 154,
	"./p2-color.jpg": 744,
	"./p2.jpg": 948,
	"./p3-color.jpg": 291,
	"./p3.jpg": 545,
	"./surf-color.jpg": 363,
	"./surf.jpg": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;